import React, { useState } from 'react';
// import loadmore from "assets/loadmore.png";
// import JaisaOsting from '../assets/Jaisa Osting.jpg'
import styled from "styled-components";
import { motion } from "framer-motion";
import { useScroll } from "./useScroll";
import { testimonialsAnimations } from "animation";

function Testimonials() {
  const [element, controls] = useScroll();
  const [selected, setSelected] = useState(0);
  const testimonials = [
    {
       // Add image URL for the first testimonial
      designation: "",
      name: "Mary Jane Montana",
      review: "I love the outcome of my hair style and first time I use the chestnut hair dye. Friendly staff."
    },
    {
       // Add image URL for the second testimonial
      designation: "",
      name: "Danielle Loyola",
      review: "Good prices and a lovely hair stylist. Will definitely come back again"
    },
    {
       // Add image URL for the third testimonial
      designation: "",
      name: "Jaisa Daniel-Osting",
      review: "Nicely done! Thanks so much!"
    },
  ];
  return (
    <Section ref={element}>
      <div className="container">
        <motion.div className="testimonials"
          variants={testimonialsAnimations}
          animate={controls}
          transition={{
            delay: 0.03,
            type: "tween",
            duration: 0.8,
          }}
        >
          {testimonials.map(({ image, designation, name, review }, index) => (
            <div className={`testimonial ${selected === index ? "active" : "hidden"}`} key={index}>
              <div className="image">
                <h1> See our Customer Reviews</h1>
                <br></br>
                <br></br>
                <br></br>
                {/* <div className="circle2">
                  <img src={image} alt={`Testimonial ${index + 1}`} />
                </div> */}
              </div>
              <div className="title-container">
                <span className="designation">{designation}</span>
                <h3 className="title">{name}</h3>
              </div>
              <p className="description">{review}</p>
            </div>
          ))}
        </motion.div>
        <motion.div className="controls"
          variants={testimonialsAnimations}
          animate={controls}
          transition={{
            delay: 0.03,
            type: "tween",
            duration: 0.8,
          }}
        >
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={selected === index ? "active" : ""}
              onClick={() => setSelected(index)}
            ></button>
          ))}
        </motion.div>
      </div>
    </Section>
  );
}

const Section = styled.section`
overflow: hidden;

.container {
  min-height: 100vh;
  background-color: var(--primary-color);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  .testimonials {
    display: flex;
    gap: 1rem;
    text-align: center;
    justify-content: center;
    width: 30%;
    .testimonial {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;
      .image {
        position: relative;
        .circle2 {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 10rem;
          width: 10rem;
          border-radius: 10rem;
          background-color: #8860e6b0;
        }
      }
    }
    .hidden {
      display: none;
    }
    color: #fff;
    .designation {
      height: 8rem;
    }
  }
  .controls{
    display: flex;
    gap: 1rem;
    button {
      padding: 0.5rem;
      border-radius: 1rem;
      background-color: var(--secondary-color);
      border: 0.1rem solid transparent;
      cursor: pointer;
    }
    .active {
      background-color: transparent;
      border: 0.1rem solid var(--secondary-color);
    }
  }
}
@media screen and (min-width: 280px) and (max-width: 1080px) { 
  .background {
    display: none;
  }
  .container {
    padding: 4rem 0;
    .testimonials {
      width: 80%;
      .testimonial {
        .description {
          height: 18rem;
        }
      }
    }
  }
}
`;

export default Testimonials